<label
  (click)="notify()"
  [attr.aria-hidden]="!icon"
  [attr.for]="name"
  [class.d-flex]="displayFlex"
  [class.d-inline-flex]="displayInlineFlex"
  [class.idp-label__height]="displayFlex"
  [class.sr-only]="topLabelSrOnly"
  [ngClass]="'text-' + role + ' ' + size + ' ' + classList"
>
  <span
    [ngClass]="{
      'idp-action-label__label--dark': emphasis,
      capitalize: transformCapitalize
    }"
    aria-hidden="true"
    class="label-text"
    id="label_{{ labelId }}"
  >
    {{ text }}
  </span>
  <ng-container
    *ngIf="
      icon === true && helpModal?.icon === true;
      then helpIconOpensModal;
      else helpIconOnly
    "
  ></ng-container>
  <ng-template #helpIconOnly>
    <a
      (click)="openModal()"
      (keydown.Enter)="openModal()"
      *ngIf="icon"
      a
      aria-haspopup="true"
      class="idp-icon-info-anchor"
      data-test-help-icon-alone="true"
      href="javascript:void(0)"
    >
      <i
        [ngClass]="'text-index-' + iconAlign"
        aria-hidden="true"
        class="idp-icon-info"
      ></i>
      <span class="sr-only">
        {{ text }} opens in a new popup{{ helpIcon ? ', help' : '' }}
      </span>
    </a>
  </ng-template>
  <ng-template #helpIconOpensModal>
    <idp-help-icon
      [labelIcon]="true"
      [modalContent]="helpModal.content"
      [modalTitle]="helpModal.title"
      [modalType]="helpModal.type"
      [srText]="helpModal.title"
    ></idp-help-icon>
  </ng-template>
</label>
